import { cn } from '~/shared/lib/cn'
import { type ImageName, IMAGES } from './images'

interface ImageryProps {
  className?: string
  name: ImageName
}

export function Imagery({ className, name }: ImageryProps) {
  const ImageComponent = IMAGES[name]

  return <ImageComponent className={cn('inline-block', className)} />
}
